import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { FIELD_STATUS_VALUES } from 'business/constants';
import type { LifeCycleStatus } from 'business/types';
import { useTranslation } from 'react-i18next';

type Props = {
    currentStatus: LifeCycleStatus;
    onChange: (newStatus: LifeCycleStatus) => void;
};

const FieldStatusSelector = ({ currentStatus, onChange }: Props) => {
    const { t } = useTranslation();
    const statusLabel = t('dataCatalog.fieldStatusManagement.status');

    return (
        <FormControl size="small">
            <InputLabel id="status-label">{statusLabel}</InputLabel>
            <Select
                id="status-select"
                labelId="status-label"
                value={currentStatus}
                label={statusLabel}
                onChange={(event) =>
                    onChange(event.target.value as LifeCycleStatus)
                }
            >
                {Object.values(FIELD_STATUS_VALUES).map((value) => (
                    <MenuItem key={value} value={value}>
                        {t(`dataCatalog.fieldStatusManagement.${value}`)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};
export default FieldStatusSelector;
